<template>
<div class="chapter">
<div class="inner_page">
<h1 class="toc" id="toc">Contents</h1>
<p class="toc1"><a class="hlink" href="#/OEBPS/9780795317361_epub_prl_r1.htm">PROLOGUE: The Aftermath</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/9780795317361_epub_c01_r1.htm">1 Origins I: A. K. Sarvis, M.D.</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/9780795317361_epub_c02_r1.htm">2 Origins II: George W. Hayduke</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/9780795317361_epub_c03_r1.htm">3 Origins III: Seldom Seen Smith</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/9780795317361_epub_c04_r1.htm">4 Origins IV: Ms. B. Abbzug</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/9780795317361_epub_c05_r1.htm">5 The Wooden Shoe Conspiracy</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/9780795317361_epub_c06_r1.htm">6 The Raid at Comb Wash</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/9780795317361_epub_c07_r1.htm">7 Hayduke’s Night March</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/9780795317361_epub_c08_r1.htm">8 Hayduke and Smith at Play</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/9780795317361_epub_c09_r1.htm">9 Search and Rescue on the Job</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/9780795317361_epub_c10_r1.htm">10 Doc and Bonnie Go Shopping</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/9780795317361_epub_c11_r1.htm">11 Back to Work</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/9780795317361_epub_c12_r1.htm">12 The Kraken’s Arm</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/9780795317361_epub_c13_r1.htm">13 Duologues</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/9780795317361_epub_c14_r1.htm">14 Working on the Railroad</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/9780795317361_epub_c15_r1.htm">15 Rest and Relaxation</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/9780795317361_epub_c16_r1.htm">16 Saturday Night in America</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/9780795317361_epub_c17_r1.htm">17 The American Logging Industry: Plans and Problems</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/9780795317361_epub_c18_r1.htm">18 Dr. Sarvis at Home</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/9780795317361_epub_c19_r1.htm">19 Strangers in the Night</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/9780795317361_epub_c20_r1.htm">20 Return to the Scene of the Crime</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/9780795317361_epub_c21_r1.htm">21 Seldom Seen at Home</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/9780795317361_epub_c22_r1.htm">22 George and Bonnie Carry On</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/9780795317361_epub_c23_r1.htm">23 At the Hidden Splendor</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/9780795317361_epub_c24_r1.htm">24 Escape of the Depredator</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/9780795317361_epub_c25_r1.htm">25 Rest Stop</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/9780795317361_epub_c26_r1.htm">26 Bridgework: Prolegomena to the Final Chase</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/9780795317361_epub_c27_r1.htm">27 On Your Feet: The Chase Begins</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/9780795317361_epub_c28_r1.htm">28 Into the Heat: The Chase Continues</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/9780795317361_epub_c29_r1.htm">29 Land’s End: One Man Left</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/9780795317361_epub_c30_r1.htm">30 Edge of the Maze: The Chase Concluded</a></p>
<p class="toc1"><a class="hlink" href="#/OEBPS/9780795317361_epub_epl_r1.htm">EPILOGUE: The New Beginning</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780795317361_epub_toc_r1.vue?48c663ea